/* eslint-disable @typescript-eslint/restrict-template-expressions */
const PORT = window.location.port || '';

// const PORT =
// 	process.env.REACT_APP_ENVIRONMENT === 'production'
// 		? `${window.location.port}`
// 		: process.env.REACT_APP_API_PORT || 3000;
const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}${
	PORT ? `:${PORT}` : ''
}`;

export {API_BASE_URL};
